export const sortingTypesEnum = Object.freeze({
    ANY: null,
    NEWEST: 'newest',
    ALPHABETIC_ASC: 'a-z',
    ALPHABETIC_DESC: 'z-a',
});
